export class MediaSegment {
  segmentId: string;
  identifier: string;
  name: string;
  remarks: string;
  start: number; // Milliseconds from the start of the source media
  end: number;   // Milliseconds from the start of the source media
}
